const Answer = () =>
  import(
    /* webpackChunkName: "questionnaire-answer" */ '@/pages/questionnaire/answer/index.vue'
  )

const CreateAnswer = () =>
  import(
    /* webpackChunkName: "questionnaire-answer" */ '@/pages/questionnaire/answer/create.vue'
  )

const EditAnswer = () =>
  import(
    /* webpackChunkName: "questionnaire-answer" */ '@/pages/questionnaire/answer/edit.vue'
  )

export default {
  path: 'answer',
  meta: {
    label: 'answer',
    auth: 'answer'
  },
  component: {
    name: 'Answer',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'QuestionnaireAnswer',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Answer
    },
    {
      name: 'QuestionnaireCreateAnswer',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateAnswer
    },
    {
      name: 'QuestionnaireEditAnswer',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditAnswer,
      props: true
    }
  ]
}
